import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useDispatch } from 'react-redux';
import authActions from 'modules/auth/authActions';
import { fromApiBoolean } from '@liquidweb-dev/club-sauce';
import useAccountDetails from 'modules/queries/account/useDetails';
import { useBasketAdmin, useMasquerade } from './useAuthenticated';

export function GtmConnector() {
	const dispatch = useDispatch();
	const context = useAuth();
	const { isLoading, user } = context;

	const isBasketAdmin = useBasketAdmin();
	const isMasquerade = useMasquerade();
	const { data: accntDetails } = useAccountDetails(
		{
			alsowith: ['customerLifecycle'],
		},
		{ enabled: !isLoading && !isBasketAdmin },
	);
	const accountNumber = accntDetails?.accnt || '';
	const newAccount = fromApiBoolean(
		accntDetails?.customerLifecycle?.new_account,
	);

	useEffect(() => {
		if (isLoading) return;

		dispatch(
			authActions.gtmIdentify({
				idData: {
					isBasketAdmin,
					isMasquerade,
					id: user?.profile?.sub,
					givenName: user?.profile?.given_name,
					familyName: user?.profile?.family_name,
					email: user?.profile?.email,
					username: user?.profile?.username,
					accountNumber,
					newAccount,
					system: 'lw',
				},
			}),
		);
	}, [
		isLoading,
		dispatch,
		isBasketAdmin,
		isMasquerade,
		user,
		accountNumber,
		newAccount,
	]);

	return null;
}

export default GtmConnector;
